import {DataTransferObject} from './DataTransferObject';
import {PublicTransportConfig} from '../Models/PublicTransportConfig';

export class PublicTransportConfigDTO extends DataTransferObject {
  passengerName: string | null = null;
  passengerSurname: string | null = null;
  usePubTrans: boolean = false;
  selectedDate: string | null = null;
  productId: number | null = null;
  slotId: number | null = null;

  fromData(data: any): PublicTransportConfigDTO {
    const pubTransConfig = new PublicTransportConfigDTO();
    pubTransConfig.passengerName = data.passengerName;
    pubTransConfig.passengerSurname = data.passengerSurname;
    pubTransConfig.usePubTrans = data.usePubTrans;
    pubTransConfig.selectedDate = data.selectedDate;
    pubTransConfig.productId = data.productId;
    pubTransConfig.slotId = data.slotId;
    return pubTransConfig;
  }

  fromModel(model: PublicTransportConfig): PublicTransportConfigDTO {
    const pubTransConfig = new PublicTransportConfigDTO();
    pubTransConfig.passengerName = model.passengerName;
    pubTransConfig.passengerSurname = model.passengerSurname;
    pubTransConfig.usePubTrans = model.usePubTrans;
    pubTransConfig.selectedDate = model.selectedDate;
    pubTransConfig.productId = model.productId;
    pubTransConfig.slotId = model.slotId;
    return pubTransConfig;
  }
}
